/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-12 21:53:41
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare کھولیو",
    name2: "ایکھ بُکنگ کریو",
    name3: "Carlcare سٕتۍ، تُہۍ ہِکیو تُہنٛد آڈر کُنتِہ وَکھ چیک کٔرِتھۍ۔",
    name4: "",
    name5: "دیچھُن کُن سلائیڈ",
    name6: "تصدیق گےٚ مکمل",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02130204983.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
  },
  order: {
    name1: "آلیک ماڈل کریومنتخب",
    name2: "غلطی ہنز تفصیل :",
    name3: "سروس سٹور منتخب کرنہ خیطرہ دبایو",
    name4: ":سروس سٹور",
    name5: ":بُکنگ ہند وقت",
    name6: "میٛہربٲنی کٔرِتھۍ کٔرِو تِہنٛز آلہ مشکلات تفصیٖل سان وضاحت!",
    name7: "واتنیک وقت منتخب کرنہ خیطرہ دبایو",
    name8: "میٛہربٲنی کٔرِتھۍ کٔرِو تِہنٛز درست رٲبطہ تفصیٖلات دٲخل تاکہ أس واتو تُہۍ تام",
    name9: "دستیاب ریزرویشن وَکھ چھُ ذیل پٲٹھ",
    name10: "مہربانی کریتھ کریو پنن فون نمبر درج ۔",
    name11: "قیمت",
    name12: "ذاتی معلومات:",
    name13: "میٛہربٲنی کٔرِتھ کٔرِو تُہنٛد ناؤ دٲخل",
    name14: "درج کریو",
    name15: "منسوخ",
    name16: "او کے",
  },
  shops: {
    name1: "تُہندہ منتخب کردہ برانڈکس بنیادس پیٹھ،بنہ کن دینہ آمیت سٹور ہیکو نیو تُہیہ سروس فراہم کریتھ!",
    name2: "مزید پرچون سٹورن مینز چھہ جلد یینہ وول! اسہ سیتھ روزیو!",
  },
  price: {
    name1: "برانڈ",
    name2: "ماڈل",
    name3: "آئٹم",
    name4: "قیمت",
    name5: "دوستانہ یاد دہٲنی:",
    name6: "یِم قیمتِ چھُ صرف حوالہ باپتھ، تِہ اصل قیمت چھُ تَہنحدٕ آلہ کِہ حالتٕ پٮ۪ٹھ مبنی۔",
    name7: "اگر نِہ ییتِہ کانٛہ خاص نِشان چھُ، قیمت چھُ مقٲمی کرنسی ہُنٛد یونٹ۔",
    name8: "موفی دِیوٗ! موجودہ علاقس مَنٛز چھُ نِہ کانٛہ قیمت انفو دستیاب۔",
    name11:"مزدوری خرچٕہ",
    name12:"کُل قیمت",
    name13: "5. اگر لیبرٕچ لاگت \"/\" چِھ، تیلہٕ چُھ امیُک مطلب یہٕ زِ لیبرٕچ لاگتس چُھ سٹورس سۭتۍ مشورٕ کرنٕچ ضرورت۔",
    item_main_board: "مین بورڈ",
    item_screen_frame: "سکرین (فریم)",
    item_screen_screen_frame: "سیکنڈری سکرین (فریم)",
    item_touch_screen: "ٹچ سکرین",
    item_camera: "کیمرہ",
    item_fixed_focus_camera: "فِکسڈ فوکْس کیمرہ",
    item_auto_focus_camera: "آٹو فوکْس کیمرہ",
    item_screen: "سکرین",
    item_secondary_screen: "سیکنڈری سکرین",
    item_fingerprint_module: "فنگر پرنٹ ماڈل",
    item_speaker: "سپیکر",
    item_receiver: "حصول کُنندہ",
    item_small_board: "لکُٹ بورڈ",
    item_battery_cover: "بیٹری کور",
    item_battery: "بیٹری",
    item_charger: "چارجر",
    item_usb_cable: "\\u200fUSB کیبل\\u200f",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "کانٛہ ڈیٹا نِہ",
    name2: "سروس پیش کرن وول:",
    name3: "سروس برانڈ:",
    name4: "ٹیلیفون:",
    name5: "آرڈریک مقدار:",
    name6: "سروس ہنز درجہ بندی",
    name7: "سروس ہند ماحول:",
    name8: "سروس یک رویہ:",
    name9: "سروسیچ اہلیت:",
    name10: "سروس ہند معیار:",
    name11: "صارفین تشخیص",
    name12:"بخدمت",
    name13:"بنٛد کۅرمُت",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare کھولیو",
    name1: "میٛہربٲنی کٔرِتھۍ کٔرِو ریزرویشن انفو سکرین شاٹ تِہ محفوظ کٔرِو یِہ از رسید ترجیح خدمت رسٲئی کرنِہ باپتھ۔",
    name2: "کامیابی سان آو پیش کرنہ",
    name3: "1. ڈیٹا کٔرِو صاف",
    name4: "میٛہربٲنی کٔرِتھۍ کٔرِو اہم نجی ڈیٹا تِہنٛدس فونس پٮ۪ٹھ گوڈنتھی بیک اپ",
    name5: "2. پاور-آن پاس ورڈ کٔرِو ناکار",
    name6: "خدمت سٹور ہس پٮ۪ٹھ گَژھنِہ برونٹھ، میٛہربٲنی کٔرِتھۍ:",
    name7: ":سروس سٹور",
    name8: ":بُکنگ ہند وقت",
    name9: "غلطی ہنز تفصیل :",
    name10: "آلیک ماڈل:",
    name11: "آڈر نمبر :",
    name12: "آرڈریچ معلومات",
  },
  title: {
    
    name1: "چھُ مندرجہ ذیل ملک سپورٹ کَران:",
    name2: "ماڈل کریو منتخب",
    name3: "بُکنگ",
    name4: "سروس سٹوریک تفصیلات",
    name5: "سرور سٹور کریو منتخب",
  },
  error: {
    
    name1: "کانٛہ ڈیٹا نِہ۔ میٛہربٲنی کٔرِتھۍ کٔرِو تُہنٛد ریپئر انفو چیک",
    name2: "مزید مددتک چھہ ضرورت؟ مہربانی کریتھ کریو اسہ سیتھ رابطہ۔",
    name3: "موفی دِیوٗ، ییتِہ چھُ نِہ موجودہ علاقس مَنٛز کانٛہ Carlcare سینٹر۔",
    name4: "میٛہربٲنی کٔرِتھۍ چُنیو گوڈِ اَکھ خدمت سینٹر",
    name5: "ناکام سَپُد",
    name6: "میٛہربٲنی کٔرِتھۍ چُنیو گوڈِ اَکھ آلہ ماڈل",
    name7: "تفصیل",
    name8: "میٛہربٲنی کٔرِتھۍ کٔرِو تِہنٛز ضروریات تفصیٖل سان وضاحت",
    name9: "",
  },
  add1:{
    "name0": "ks",
    "name1": "تُہنٛد آڈر آؤ تصدیق کرنٕہ۔ أس چھُ تَہنٛز ارسال باپتھ کوشاں۔",
    "name2": "شہر کٔرِو منتخب",
    "name3": "مہربأنی کأریتھ کأریو فون نمبر دأخل%1$s نمبرات۔",
    "name4": "آتھوارء ہند گنٹء",
    "name5": "ژندروار",
    "name6": "بھوم وار",
    "name7": "بودوار",
    "name8": "برسوار",
    "name9": "جمعہ",
    "name10": "بٹہ وار",
    "name11": "آتھوار",
    "name12": "أژئیو ملکس منز تء ژأنڈیو"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "دیگر",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ری ڈائریکٹ کرنٕہ باپتھ کٔرِو ٹیپ",
    name3:"آرڈرٕچ ریٹ کرنہٕ باپتھ کٔرِو Carlcare ایپ اوپْن",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"سروِس کٔرِو منتخب",
    name7:"مُفت صفٲئی",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "غیر درست اِنفو",
    "cancelReason1": "ہیکٕہ نٕہ وقتس پٮ۪ٹھۍ وٲتِتھۍ",
    "cancelReason2": "نقلی آڈر/چھُ نٕہ مِیوٗن آڈر",
    "cancelReason3": "ناکٲمی چھُ نٕہ تکرار",
    "cancelReason4": "صرف ٹیسٹ/پوچھ تاچھ/تقریب/۔۔۔ باپتھ",
    "cancelReason5": "زِیادٕ درۅگ",
    "cancelReason6": "مواد سِٹوریج",
    "cancelReason7": "کانٛہ مختلف خدمات نٕہ",
    "cancelReason8": "سِٹور چھُ واریاہ دوٗر",
    "cancelReason9": "سِٹور چھُ بند گومُت",
    "cancelReason10": "خراب خدمت ورتاؤ",
    "cancelReason11": "باقی برانڈس باپتھ متبادل/مرمت",
    "cancelReason12": "ہیکٕہ نٕہ سٹور لٔبیتھۍ",
    "cancelReason13": "دویم",
    "cancelOrder": "آرڈر کریو منسوخ",
    "reason_dialog_title": "میٛہربٲنی کٔرِتھۍ ؤنیو اَسِہ منسوخی ہُنٛد وجہ",
    "Cancel": "منسوخ",
    "OK": "او کے",
    "name1": "Enter verification code",
    "name2": "غٲر درست تصدیقی کوڈ",
    "repair_reservation_detail_canceled": "یہ آرڈر چھہ آمت منسوخ کرنہ!",
    "purchase_cancel_dialog_content": "کیٛاہ تُہۍ چھِوا آرڈر رد کرُن کرنٕچ تصدیٖق کران؟",
    "yes": "اوا",
    "no": "نہہ"
}
};
